import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOSSOLOADINGMODAL_LEGACY_FIELD_ORDER = [
  "legal_checkbox_label"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoSsoLoadingModalDescriptor: _generatedComoSsoLoadingModalDescriptor,
  comoSsoLoadingModalModalDefinition,
  comoSsoLoadingModalDashboardLayout,
  comoSsoLoadingModalConfig,
  comoSsoLoadingModalResolveConfig,
  comoSsoLoadingModalProperties,
} = doodModalConfig(
  {
    name: "Como - SSO loading modal",
    handle: "como-sso-loading-modal",
    internal_name: "ComoSsoLoadingModal",
    componentType: 'ComoSsoLoadingModalComponent',
    category: 'modal',
    description: "Como - SSO loading modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "como-sso-loading-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    legal_checkbox_label: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        "label": "Legal checkbox label",
        "help": "Legal text displayed next to the consent checkbox"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "legal_checkbox_label"],
          },
        ],
      },
    ],
  })
);

export function comoSsoLoadingModalDescriptor(): IBlockDescriptor;
export function comoSsoLoadingModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoSsoLoadingModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoSsoLoadingModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoSsoLoadingModalDescriptor, comoSsoLoadingModalProperties, fieldOrder);
}

export {
  comoSsoLoadingModalModalDefinition,
  comoSsoLoadingModalDashboardLayout,
  comoSsoLoadingModalProperties,
  comoSsoLoadingModalConfig,
  comoSsoLoadingModalResolveConfig,
};

export type ComoSsoLoadingModalConfig = typeof comoSsoLoadingModalConfig;
